import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import uuid from 'react-uuid'
import Textbox from './Textbox'
//Redux
import { setTextboxes } from '../../../redux'
import { useSelector, useDispatch } from 'react-redux'

function TextboxManager(props) {
  const { textboxRefresh, saveRefresh, pageNumber, handleRecords } = props
  const COURIER = 'Courier'
  const FONT_MULTIPLIER = 1.333333333333333

  const [textboxArray, setTextboxArray] = useState([])
  const dispatch = useDispatch()
  const page = useSelector((state) => state.document.page)

  useEffect(() => {
    if (textboxRefresh && textboxRefresh !== 0) addTextbox()
  }, [textboxRefresh])

  useEffect(() => {
    if (saveRefresh && saveRefresh !== 0) saveTextboxes()
  }, [saveRefresh])

  const addTextbox = () => {
    setTextboxArray([
      ...textboxArray,
      {
        id: uuid(),
        value: '',
        fontFamily: COURIER,
        fontSize: 20,
        fontWeight: 'Normal',
        fontStyle: 'Normal',
        color: { r: 0, g: 0, b: 0 },
        tbLeft: page.offsetLeft + 50,
        tbTop: page.offsetTop + 50,
        tbHeight: 20 * FONT_MULTIPLIER,
        tbWidth: 100,
        pageNumber: page.pageNumber,
        offsetLeft: page.offsetLeft,
        offsetTop: page.offsetTop,
        multiplier: page.originalPageHeight / page.pageHeight,
        pageHeight: page.pageHeight,
        pageWidth: page.pageWidth,
      },
    ])
    handleRecords(pageNumber, 'textbox', 'increment')
  }

  const saveTextboxes = () => {
    dispatch(setTextboxes(textboxArray))
  }
  const deleteTextbox = (id) => {
    setTextboxArray(textboxArray.filter((tb) => tb.id !== id))

    handleRecords(pageNumber, 'textbox', 'decrement')
  }

  const updateTextbox = (state) => {
    setTextboxArray(textboxArray.map((tb) => (tb.id === state.id ? { ...tb, ...state } : tb)))
  }

  return (
    <div>
      {textboxArray.map((textbox) => {
        return <Textbox key={textbox.id} updateTextbox={updateTextbox} deleteTextbox={deleteTextbox} textbox={textbox} />
      })}
    </div>
  )
}
TextboxManager.propTypes = {
  textboxRefresh: PropTypes.number.isRequired,
  saveRefresh: PropTypes.number.isRequired,
  pageNumber: PropTypes.number.isRequired,
  handleRecords: PropTypes.func.isRequired,
}

export default TextboxManager
